<template>
  <div class="container-fluid" id="faskesProfile">
    <div class="row">
      <div class="col-md-12 mb-2">
        <h3 style="font-weight:700">Know Your Customers (KYC)</h3>
      </div>
      <div class="col-md-12">
        <div class="row equal-height-row">
          <!-- profile -->
          <div class="col-md-12 d-flex flex-column pl-0 faskes-fasilitas">
            <div class="card card-box mb-3 ">
              <div class="card-body p-5">
                <!-- Image Profile -->
                <div class="row mb-5">
                  <div class="col-md-12">
                    <div class="profile d-flex justify-content-center">
                      <div class="profile-custom">
                        <img :src="imgURL" alt="" srcset="" />
                      </div>
                    </div>
                  </div>
                </div>
                <!-- End Image Profile -->

                <!-- Infor Profile -->
                <div class="row">
                  <div class="col-md-6">
                    <b-form-group>
                      <label for=""
                        >Nama Lengkap<span style="color:red">*</span></label
                      >
                      <b-form-input
                        type="text"
                        v-model="formProfile.name"
                        placeholder="Input nama lengkap sesuai KTP"
                        @input="inputName($event)"
                      ></b-form-input>
                      <span
                        style="color:red"
                        v-if="formProfile.errors.name.message"
                      >
                        {{ formProfile.errors.name.message }}
                      </span>
                    </b-form-group>
                  </div>
                  <div class="col-md-6">
                    <b-form-group>
                      <label for="">NIK<span style="color:red">*</span></label>
                      <b-form-input
                        type="text"
                        maxlength="50"
                        v-model="formProfile.nik"
                        placeholder="Masukan NIK"
                        @paste="pasteNik($event)"
                        @keypress="keypressNik($event)"
                        @input="inputNik($event)"
                      ></b-form-input>
                      <span
                        style="color:red"
                        v-if="formProfile.errors.nik.message"
                      >
                        {{ formProfile.errors.nik.message }}
                      </span>
                    </b-form-group>
                  </div>
                </div>
                <div class="row mt-4">
                  <div class="col-md-12 mb-3">
                    <b-button
                      variant="primary"
                      class="float-right"
                      @click="onSubmit"
                      >Verifikasi Pengguna</b-button
                    >
                  </div>
                </div>
                <!-- End Info Profile -->
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { mapGetters } from "vuex";
import { counter, library } from "@fortawesome/fontawesome-svg-core";
import {
  faInfo,
  faFolder,
  faCamera,
  faTimes
} from "@fortawesome/free-solid-svg-icons";
library.add(faInfo, faCamera, faFolder, faTimes);
import { EventBus } from "../../event-bus";

export default {
  components: {},
  data() {
    return {
      imgURL: "/img/satusehat_logo.png",

      formProfile: {
        name: "",
        nik: "",
        errors: null
      }
    };
  },
  created() {
    this.buildErrorMessage();
  },
  mounted() {
    window.swal = this.$swal;

    // default name & nik as dokter
    if(this.isDokter) {
      const user = this.$store.state.user;
      this.formProfile.name = user.dokter[0].nama;
      this.formProfile.nik = user.dokter[0].nik;
    } else {
      this.getProfile();
    }
  },
  computed: {
    ...mapGetters(["getKlinikId", "getRolesName", "getFaskesType"]),
    isPic() {
      return /pic/.test(this.getRolesName);
    },
    isDpm() {
      return this.getFaskesType;
    },
    isDokter() {
      const condition1 =  (/dokter/.test(this.getRolesName));

      return condition1;
    },
  },
  watch: {},
  methods: {
    async getProfile() {
      try {
        var profile = this.$store.state.user.id;
        const res = await this.$axios.get(
          `klinik/user/${profile}?klinik_id=${this.getKlinikId}`
        );

        const { data } = res.data;
        this.formProfile = {
          ...this.formProfile,
          name: data.nama_kyc,
          nik: data.nik_kyc
        };
      } catch (e) {}
    },
    buildErrorMessage() {
      this.formProfile.errors = {
        status: false,
        name: {
          error: false,
          message: ""
        },
        nik: {
          error: false,
          message: ""
        }
      };
    },
    hasFeatures(value) {
      const features = {
        manajemen: ["owner_klinik", "manajemen"],
        klinik: ["pic_cabang", "pic_pusat"],
        dokter: ["dokter_klinik"]
      };
      const isOwner = features[value].filter(feature => {
        return this.getRolesName.includes(feature);
      });
      return isOwner.length > 0 ? true : false;
    },
    inputName(value) {
      this.removeErrorField("name");
      if (!value) {
        this.addErrorField("name", `Nama Lengkap harus diisi`);
        return;
      }
    },
    keypressNik(evt) {
      evt = evt ? evt : window.event;
      var charCode = evt.which ? evt.which : evt.keyCode;

      if (evt.target.value.length > 15) {
        evt.preventDefault();
      }

      if (
        charCode > 31 &&
        (charCode < 48 || charCode > 57) &&
        charCode !== 46
      ) {
        evt.preventDefault();
      } else {
        return true;
      }
    },
    inputNik(value) {
      this.removeErrorField("nik");

      if (!value) {
        this.addErrorField("nik", `NIK harus diisi`);
        return;
      }

      if (!/^\d+$/.test(value) || value.length != 16) {
        this.addErrorField("nik", "NIK Minimal 16 Angka");
      } else {
        this.removeErrorField("nik");
      }
    },
    pasteNik(evt) {
        setTimeout(() => {
          const value = evt.target.value;
          if (!/^\d+$/.test(value) || value.length > 16) {
            this.formProfile.nik = ''
          }
        }, 0);
    },
    addErrorField(field, message) {
      this.formProfile.errors.status = true;
      this.formProfile.errors[field] = {
        error: true,
        message
      };
    },
    removeErrorField(field) {
      this.formProfile.errors[field] = {
        error: false,
        message: ""
      };
    },
    requiredValidation() {
      const field = ["name", "nik"];
      const fieldLabel = ["Nama Lengkap", "NIK"];

      for (const [index, attr] of field.entries()) {
        if (!this.formProfile[attr]) {
          this.addErrorField(attr, `${fieldLabel[index]} harus diisi`);
        }
      }
    },
    errorExist() {
      const errors = Object.assign({}, this.formProfile.errors);
      delete errors.status;

      for (const attr in errors) {
        if (errors[attr].message) {
          return true;
        }
      }
    },
    onSubmit() {
      this.requiredValidation();

      if (this.errorExist()) {
        return;
      }

      let payload = {
        nama_kyc: this.formProfile.name,
        nik_kyc: this.formProfile.nik,
        klinik_id: this.getKlinikId,
        id_user: this.$store.state.user.id
      };

      this.$axios
        .post(`satu-sehat/kyc/generate-url`, payload)
        .then(response => {
        //   {
        //     "success": true,
        //     "message": "Generate url successful",
        //     "data": {
        //         "metadata": {
        //             "code": "200",
        //             "message": "OK"
        //         },
        //         "data": {
        //             "agent_name": "patient 1",
        //             "agent_nik": "9271060312000001",
        //             "token": "a537c0ba-e5c9-4d4e-aec2-12f43882c951",
        //             "url": "https://api-satusehat-stg.dto.kemkes.go.id/kyc/v1/validation-web/a537c0ba-e5c9-4d4e-aec2-12f43882c951"
        //         }
        //     }
        // }
          const { data } = response.data.data;

          if (response.data.status) {
            window.open(data.data.url)
          } else {
            throw new Error("failed");
          }
        })
        .catch(error => {
          this.$swal({
            type: "error",
            title: "Generate URl KYC",
            text: "Gagal generate URl KYC",
            width: "700px"
          });
        });
    }
  }
};
</script>
<style>
#faskesProfile {
  transform: scale(0.78);
  width: 128%;
  margin-left: -14%;
  /* margin-top: -100px; */
  font-size: 12pt;
}
</style>
<style scoped>
.__blue {
  color: #4b80b6;
}
.__icon_add_photo {
  position: absolute;
  top: 12px;
  left: 14px;
}
.__btn_add_photo {
  position: absolute;
  top: 85px;
  right: -20px;
  z-index: 20;
  border-radius: 50%;
  height: 44px !important;
  background-color: rgb(121, 121, 121);
}
.delete_photo {
  position: absolute;
  width: 100%;
  height: 20%;
  top: 30%;
  z-index: 9;
  font-size: 30pt;
  text-align: center;
}
.profile-custom {
  width: 100%;
  height: 100%;
  position: relative;
  text-align: center;
  /* border: 1px solid #cdcdcd; */
}

.profile-custom img {
  width: 350px;
  object-fit: cover;
}
</style>
